import React, { useState, useEffect, useRef, useLayoutEffect } from "react";

import Button from "react-bootstrap/Button";
import "./CreateReport.css";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Stack from "react-bootstrap/Stack";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ToggleButton from "react-bootstrap/ToggleButton";
import axios from "axios";
import Dropdown from "react-bootstrap/Dropdown";
import Card from "react-bootstrap/Card";
import CardGroup from "react-bootstrap/CardGroup";
import Moment from "react-moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import Spinner from "react-bootstrap/Spinner";
import Modal from "react-bootstrap/Modal";
import { ProfileView } from "../pages/ProfileView";

export const CreateReport = () => {
  const textareaRef = useRef(null);

  function onClickBackToCopilot() {
    window.location.href = "/?selected_index=" + selected_index;
  }

  const handleCloseDataModel = () => setShowConfirmation(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [reportToDelete, setReportToDelete] = useState();

  function deleteConfirmed() {
    setShowDeleteModal(true);
    setShowConfirmation(false);

    axios
      .post(
        process.env.REACT_APP_API_DOMAIN + "/deleteTopic",
        {
          reportId: reportToDelete,
          ownerId: userProfile.email,
          partnerId: partners[selected_index].partner_id,
        },
        {
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        setUserReports(response.data.reports);
        setShowDeleteModal(false);
        var fReport = [];
        for (var r in response.data.reports) {
          var rObj = response.data.reports[r];
          var newObj = {};
          newObj["content_size"] = rObj["content_size"];
          var isoTimestamp = rObj["timestamp"].replace(" ", "T");
          isoTimestamp += "Z";
          const localDate = new Date(isoTimestamp);
          const localTimeString = localDate.toLocaleString();
          const localTimeISO = Math.floor(
            new Date(isoTimestamp).getTime() / 1000
          );
          newObj["timestamp"] = localTimeString;
          newObj["raw_time"] = localTimeISO;
          newObj["daterange"] = rObj["daterange"];
          newObj["title"] = rObj["title"];
          newObj["slide_numbers"] = rObj["slide_numbers"];
          newObj["id"] = rObj["id"];
          newObj["prompt"] = rObj["prompt"];

          fReport.push(newObj);
        }
        fReport = fReport.sort(function (x, y) {
          return x.raw_time - y.raw_time;
        });
        fReport.reverse();
        setFormatUserReports(fReport);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  function deleteReport(reportId) {
    setReportToDelete(reportId);
    setShowConfirmation(true);
  }
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const tableRef = useRef(null);

  const queryParameters = new URLSearchParams(window.location.search);
  const [partners, setPartners] = useState([]);

  const [userReports, setUserReports] = useState([]);
  const [formatUserReports, setFormatUserReports] = useState([]);

  const [radioNumPagesValue, setRadioNumPagesValue] = useState("0");
  const [radioNumPagesName, setRadioNumPagesName] = useState("Surprise Me");

  const [checked, setChecked] = useState(false);
  const [radioDateValue, setRadioDateValue] = useState("2");
  const [radioDateName, setRadioDateName] = useState("3 Months");

  const [radioTextValue, setRadioTextValue] = useState("2");
  const [radioAudienceValue, setRadioAudienceValue] = useState("1");
  const [radioContentValue, setRadioContentValue] = useState("0");

  const [radioContentName, setRadioContentName] = useState("Medium");

  const [userProfile, setUserProfile] = useState(
    JSON.parse(localStorage.getItem("g_profile"))
  );
  var selected_index_prop = queryParameters.get("selected_index");
  if (selected_index_prop == undefined) {
    selected_index_prop = 0;
  }
  const [selected_index, setSelectedIndex] = useState(selected_index_prop);
  const [selectedPartner, setSelectedPartner] = useState(
    partners[selected_index]
  );
  const [textValue, setTextValue] = useState("");
  const onTextChange = (event) => setTextValue(event.target.value);

  useLayoutEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "inherit";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [textValue]);

  // function deleteCard() {
  //   setIsProcessing(true);

  //   axios
  //     .post(
  //       process.env.REACT_APP_API_DOMAIN + "/deleteSubTopic",
  //       {
  //         subTopicId: props.slide.id,
  //         reportId: props.slide.topic_id,
  //       },
  //       {
  //         headers: {
  //           authorization: `Bearer ${localStorage.getItem("token")}`,
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     )
  //     .then((response) => {
  //       props.setSlides(response.data.subtopics);
  //       setIsProcessing(false);
  //       props.setRadioNumPagesName(
  //         response.data.report.slide_numbers.toString() + " Slides"
  //       );
  //       props.setNumPages(
  //         response.data.report.slide_numbers.toString() + " Slides"
  //       );
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // }

  const onSelectContentLength = (eventKey, event) => {
    setRadioContentName(event.target.name);
    setRadioContentValue(event.target.value);
  };

  const onSelectPartner = (eventKey, event) => {
    const new_partner = event.target.name;
    var ctr = 0;
    for (var p in partners) {
      let p_obj = partners[p];
      if (p_obj.partner_name == new_partner) {
        setSelectedPartner(p_obj);
        setSelectedIndex(ctr);
      }
      ctr++;
    }
  };

  const onSelectPages = (eventKey, event) => {
    setRadioNumPagesName(event.target.name);
    setRadioNumPagesValue(event.target.value);
  };

  const onSelect = (eventKey, event) => {
    setRadioDateName(event.target.name);
    setRadioDateValue(event.target.value);
    console.log("event.target.value", event.target.name);
  };

  const onSelectPrompt = (prompt) => {
    console.log(prompt);
    setTextValue(prompt);
  };

  function generateReport() {
    var numPages = radioNumPagesName;

    if (numPages == "Surprise Me") {
      numPages = "0";
    }

    const dateRange = radioDateName;
    const textLength = radioContentName;
    const content = textValue;

    const partnerName = partners[selected_index].partner_name;
    const partnerId = partners[selected_index].partner_id;

    window.location.href =
      "/outlineEditor?textLength=" +
      textLength +
      "&content=" +
      content +
      "&dateRange=" +
      dateRange +
      "&queryContent=" +
      textValue +
      "&partnerName=" +
      partnerName +
      "&partnerIcon=" +
      selectedPartner.icon +
      "&partnerId=" +
      partnerId +
      "&numPages=" +
      numPages +
      "&selected_index=" +
      selected_index;
  }

  const dateRangeRadios = [
    { name: "1 month", value: "1" },
    { name: "3 months", value: "2" },
    { name: "6 months", value: "3" },
    { name: "1 Year", value: "4" },
  ];

  const examplePrompts = [
    "Regional Loan Volume",
    "Loan Term Analysis",
    "Collection Rates",
    "Loan Volume By Loan Type",
  ];

  const pageNumRadios = [
    { name: "Surprise Me", value: "0" },

    { name: "2 Slides", value: "1" },
    { name: "3 Slides", value: "2" },
    { name: "4 Slides", value: "3" },
    { name: "5 Slides", value: "4" },
    { name: "6 Slides", value: "5" },
    { name: "7 Slides", value: "6" },
    { name: "8 Slides", value: "7" },
    { name: "9 Slides", value: "8" },
    { name: "10 Slides", value: "9" },
  ];

  const amountOfTextRadios = [
    { name: "Brief", value: "1" },
    { name: "Medium", value: "2" },
    { name: "Detailed", value: "3" },
  ];

  const audienceRadios = [
    { name: "Executives", value: "1" },
    { name: "Analysts", value: "2" },
    { name: "Managers", value: "3" },
  ];

  const contentRadios = [
    { name: "Free Form", value: "1" },
    { name: "Card by Card", value: "2" },
  ];

  useEffect(() => {
    axios

      .post(
        process.env.REACT_APP_API_DOMAIN + "/get_partners",
        {
          sender_id: userProfile.email,
        },
        {
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        setPartners(response.data);
        setSelectedPartner(response.data[selected_index]);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    console.log("selected_index", selected_index);
    if (
      partners.length > 0 &&
      selected_index != undefined &&
      selected_index != "null"
    ) {
      axios
        .post(
          process.env.REACT_APP_API_DOMAIN + "/getReportsByOwner",
          {
            ownerId: userProfile.email,
            partnerId: partners[selected_index].partner_id,
          },
          {
            headers: {
              authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          setUserReports(response.data.reports);

          var fReport = [];
          for (var r in response.data.reports) {
            var rObj = response.data.reports[r];
            var newObj = {};
            newObj["content_size"] = rObj["content_size"];

            var isoTimestamp = rObj["timestamp"].replace(" ", "T");
            isoTimestamp += "Z";
            const localDate = new Date(isoTimestamp);
            const localTimeString = localDate.toLocaleString();
            const localTimeISO = Math.floor(
              new Date(isoTimestamp).getTime() / 1000
            );

            newObj["timestamp"] = localTimeString;
            newObj["raw_time"] = localTimeISO;

            newObj["daterange"] = rObj["daterange"];
            newObj["title"] = rObj["title"];
            newObj["slide_numbers"] = rObj["slide_numbers"];
            newObj["id"] = rObj["id"];
            newObj["prompt"] = rObj["topic"];

            fReport.push(newObj);
          }
          fReport = fReport.sort(function (x, y) {
            return x.raw_time - y.raw_time;
          });
          fReport.reverse();
          setFormatUserReports(fReport);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [partners, selected_index]);

  return (
    <div className="reportBackground">
      <ProfileView />
      <Modal show={showConfirmation} onHide={handleCloseDataModel} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedPartner != undefined ? (
            <div>Are you sure you want to delete this Jam</div>
          ) : (
            <div></div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseDataModel}>
            Close
          </Button>{" "}
          <Button variant="danger" onClick={deleteConfirmed}>
            Delete
          </Button>{" "}
        </Modal.Footer>
      </Modal>
      <Modal show={showDeleteModal} size="lg">
        <Modal.Header>
          <Modal.Title>Deleting Jam</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {" "}
          <div className="pendingDelete">
            <Spinner animation="border" variant="primary" />
          </div>
        </Modal.Body>
      </Modal>
      <div className="cornerHeader">
        <Button
          className="backButton"
          onClick={onClickBackToCopilot}
          variant="light"
          size="sm"
        >
          Back
        </Button>
        {selectedPartner ? (
          <div className="editHeader">
            {selectedPartner.partner_name.replace("_", " ")}
            <img
              className="buidlReportIcon"
              src={selectedPartner.icon}
              alt=""
            />
          </div>
        ) : (
          <div></div>
        )}
      </div>
      <div className="createReportTitle">Generate Your Jam</div>

      <div className="createReportContainer">
        <Container>
          <Row>
            {/* Date Range
            <br></br> */}
            <div className="optionRow">
              <div className="optionContainer">
                <div className="dropdownLabel">Number of Slides</div>
                <Dropdown onSelect={onSelectPages}>
                  <Dropdown.Toggle
                    className="dropDown"
                    variant="secondary"
                    id="dropdown-basic"
                  >
                    {radioNumPagesName}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    {pageNumRadios.map((radio, idx) => (
                      <Dropdown.Item
                        key={`radioText-${idx}`}
                        id={`radioDate-${idx}`}
                        type="radio"
                        variant="secondary"
                        name={radio.name}
                        value={radio.value}
                        active={radioContentValue === radio.value}
                      >
                        {radio.name}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              {/* Amount of Text Per Card <br></br> */}
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              <div className="optionContainer">
                <div className="dropdownLabel">Date Range</div>

                <Dropdown onSelect={onSelect}>
                  <Dropdown.Toggle
                    className="dropDown"
                    variant="secondary"
                    id="dropdown-basic"
                  >
                    {radioDateName}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    {dateRangeRadios.map((radio, idx) => (
                      <Dropdown.Item
                        key={`radioText-${idx}`}
                        id={`radioDate-${idx}`}
                        type="radio"
                        variant="secondary"
                        name={radio.name}
                        value={radio.value}
                        active={radioContentValue === radio.value}
                      >
                        {radio.name}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>

              {/* Amount of Text Per Card <br></br> */}
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              <div className="optionContainer">
                <div className="dropdownLabel">Content Length</div>

                <Dropdown onSelect={onSelectContentLength}>
                  <Dropdown.Toggle
                    className="dropDown"
                    variant="secondary"
                    id="dropdown-basic"
                  >
                    {radioContentName}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    {amountOfTextRadios.map((radio, idx) => (
                      <Dropdown.Item
                        key={`radioText-${idx}`}
                        id={`radioDate-${idx}`}
                        type="radio"
                        variant="light"
                        name={radio.name}
                        value={radio.value}
                        active={radioDateValue === radio.value}
                      >
                        {radio.name}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>

              <Dropdown onSelect={onSelectPartner}>
                {partners.length > 1 && selectedPartner != undefined ? (
                  <div>
                    {" "}
                    <div className="optionContainer">
                      <div className="dropdownLabel">Partner</div>

                      <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                        {selectedPartner.partner_name}
                      </Dropdown.Toggle>
                    </div>
                  </div>
                ) : (
                  <div></div>
                )}

                <Dropdown.Menu>
                  {selectedPartner != undefined ? (
                    <div>
                      {" "}
                      {partners.map((partner, index) => (
                        <Dropdown.Item
                          key={index}
                          name={partner.partner_name}
                          active={
                            selectedPartner.partner_name ===
                            partner.partner_name
                          }
                        >
                          {partner.partner_name}
                        </Dropdown.Item>
                      ))}
                    </div>
                  ) : (
                    <div></div>
                  )}
                </Dropdown.Menu>
              </Dropdown>
            </div>

            <Col>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlTextarea1"
              >
                <div className="textAreaContainer">
                  <Form.Control
                    as="textarea"
                    ref={textareaRef}
                    placeholder="Ask anything about your data"
                    onChange={onTextChange}
                    value={textValue}
                    style={{
                      overflow: "hidden",
                      resize: "none",
                      minHeight: "40px",
                    }}
                  />
                </div>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col> </Col>
          </Row>
          {textValue != "" ? (
            <div className="generateReady">
              {" "}
              <Button className="generateJamButton" onClick={generateReport}>
                Generate Outline
              </Button>
            </div>
          ) : (
            <div className="exampleJams">
              <div>
                <hr></hr>
              </div>
              <div>Example Prompts</div>
              <div>
                <hr></hr>
              </div>

              <Row xs={1} md={2} className="g-3">
                {examplePrompts.map((prompt, idx) => (
                  <Col key={idx}>
                    <Card
                      className="yourPrompts"
                      onClick={() => onSelectPrompt(prompt)}
                      style={{ cursor: "pointer" }}
                    >
                      <Card.Body>
                        <Card.Text>{prompt}</Card.Text>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            </div>
          )}

          {userReports != undefined && userReports.length > 0 ? (
            <div className="reportsContainer">
              <div className="exampleJams">
                <div>
                  <hr></hr>
                </div>
                <div>Your Recent Prompts</div>
                <div>
                  <hr></hr>
                </div>
              </div>
              <Row xs={1} md={1} className="g-3">
                {formatUserReports.map((row, idx) => (
                  <Col key={idx}>
                    <a
                      className="noHover"
                      href={
                        "/outlineEditor?reportId=" +
                        row.id +
                        "&selected_index=" +
                        selected_index
                      }
                    >
                      <Card
                        className="yourPrompts"
                        style={{ cursor: "pointer" }}
                      >
                        <Card.Body>
                          <Card.Text>
                            <div className="yourPromptTitle">{row.prompt}</div>
                            <div className="yourPromptTime">
                              Generate -{" "}
                              <Moment fromNow>{row.timestamp}</Moment>
                            </div>
                          </Card.Text>
                          {/* <div className="delete_card">
                            <Button
                              onClick={deleteCard}
                              variant="link"
                              className="deleteButton"
                            >
                              <FontAwesomeIcon
                                icon={faTrash}
                                color="lightGray"
                                size="sm"
                              />
                            </Button>
                          </div> */}
                        </Card.Body>
                      </Card>
                    </a>
                  </Col>
                ))}
              </Row>

              {/* <table id="table" ref={tableRef} className="reportsTable">
                <thead>
                  <tr>
                    <th>Report Tittle</th>
                    <th>Date Range</th>
                    <th>Content Length</th>
                    <th>Number of Slides</th>
                    <th>Last Edited</th>
                    <th>Delete</th>
                  </tr>
                </thead>
                <tbody>
                  {formatUserReports.map((row, index) => (
                    <tr key={index}>
                      <td className="reportTitleLink">
                        <a
                          href={
                            "/outlineEditor?reportId=" +
                            row.id +
                            "&selected_index=" +
                            selected_index
                          }
                        >
                          {row.title}
                        </a>
                      </td>
                      <td>{row.daterange}</td>
                      <td>{row.content_size}</td>
                      <td>{row.slide_numbers}</td>
                      <td>
                        {" "}
                        <Moment fromNow>{row.timestamp}</Moment>
                      </td>
                      <td>
                        {" "}
                        <Button
                          onClick={() => deleteReport(row.id)}
                          variant="link"
                          className="deleteButton"
                        >
                          <FontAwesomeIcon
                            icon={faTrash}
                            color="lightGray"
                            size="sm"
                          />
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table> */}
            </div>
          ) : (
            <div></div>
          )}
        </Container>
        <p>&nbsp;</p>
      </div>
    </div>
  );
};

export default CreateReport;
